<template>
    <v-app>
        <NavBar/>
        <v-content>
          <v-container fluid>
             <v-slide-y-transition mode="out-in">
                <v-layout column>
                    <router-view></router-view>
                 </v-layout>
                </v-slide-y-transition>
            </v-container>
        </v-content>

        <v-footer app style="text-decoration: none;display: block;padding: 10px;">
            <a style="text-decoration: none;z-index: 19999999" href="https:///www.sagresimoveis.com.br" target="_blank">
                <span color="#FFFFFF" class="text--white">&copy;  {{provider}} 2019</span>
            </a>
            <a style="text-decoration: none;z-index: 19999999;float: right;" href="https:///www.allurecomunicacao.com.br" target="_blank">
                <span color="#CCCCCC">By Allure</span>
            </a>
        </v-footer>

        <div class="overlay-loading" v-if="$store.state.loading">
            <div class="loader modal"></div>
        </div>

    </v-app>
</template>
<style>
    .text-title-header{
        font-size: 12px;
        color: #868a91;
    }
</style>
<script>
    import NavBar from '@/components/NavBar'
    export default {
        components: {NavBar},
        data() {
            return {
                provider:'Sagres imóveis'
            }
        },
        methods: {

        },
        created() {
            var link = document.createElement('meta');
            link.setAttribute('property', 'og:url');
            link.content = document.location;
            document.getElementsByTagName('head')[0].appendChild(link);
        }
    }
</script>
